import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { map } from 'lodash';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Moment from 'react-moment';
import 'react-widgets/dist/css/react-widgets.css';
import * as constants from '../../../constants/constants';
import {
  getSuspiciousFoldPlayers,
  getGlobalRoomData,
} from '../../../actions/admin';
import PaginationOld from '../Menu/PaginationOld';

const SuspiciousFoldPlayers = ({ openRoomModal, offset }) => {

  const { t } = useTranslation('admin');
  const dispatch = useDispatch();
  
  const allSuspiciousFoldPlayers = useSelector(state => state.admin.suspiciousFoldPlayers || []);
  const globalRoomData = useSelector(state => state.admin.globalRoomData || {});

  const [openModal, setOpenModal] = useState(false);
  const [selectId, setSelectId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 50;

  useEffect(() => {
    dispatch(getSuspiciousFoldPlayers());
  }, []);

  useEffect(() => {
    if (selectId && globalRoomData[selectId]) {
      openRoomModal(globalRoomData[selectId]);
      setSelectId(null);
    }
  }, [selectId, globalRoomData]);

  const handlePagination = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  const openModalFunc = (item) => {
    dispatch(getGlobalRoomData(item.roomId));
    setSelectId(item.roomId);
  };

  // if (selectId && globalRoomData[selectId]) {
  //   openRoomModal(globalRoomData[selectId]);
  //   setSelectId(null);
  // }
  const pagesCount = Math.ceil(allSuspiciousFoldPlayers.length / pageSize);

  return (
    <Fragment>
      <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
        <colgroup>
          <col span="1" className="" />
        </colgroup>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>
              Date
            </th>
            <th style={{ textAlign: 'center' }}>
              Player Id
            </th>
            <th style={{ textAlign: 'center' }}>
              Name
            </th>
            <th style={{ textAlign: 'center' }}>
              Room Id
            </th>
            <th style={{ textAlign: 'center' }}>
              Count
            </th>
            <th style={{ textAlign: 'center' }}>
              View
            </th>
          </tr>
        </thead>
        <tbody>
          {allSuspiciousFoldPlayers && map(allSuspiciousFoldPlayers.slice(currentPage * pageSize, (currentPage + 1) * pageSize), (item, key) => (
            <Fragment key={key}>
              <tr key={key} className="allUsers-table-row">
                <td className="allUsers-table-col">
                  <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                    {item.dateAdded + offset}
                  </Moment>
                </td>
                <td className="allUsers-table-col">
                  {item.uid}
                </td>
                <th style={{ textAlign: 'center' }}>
                  {item.userName}
                </th>
                <th style={{ textAlign: 'center' }}>
                  {item.roomId}
                </th>
                <td className="allUsers-table-col">
                  {item.count}
                </td>
                <td className="allUsers-table-col">
                  <Button onClick={() => openModalFunc(item)}>
                    View
                  </Button>
                </td>
              </tr>
            </Fragment>
          ))}
        </tbody>
      </table>

      <PaginationOld
        show={true}
        currentPage={currentPage}
        pagesCount={pagesCount}
        handlePagination={handlePagination}
      />

      <Modal container={`div > div`} isOpen={openModal} toggle={openModalFunc} size="lg">
        <ModalHeader toggle={openModalFunc}>
          Data
        </ModalHeader>
        <ModalBody>
          <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>
                  Date
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Bet
                </th>
                <th style={{ textAlign: 'center' }}>
                  Min Rounds
                </th>
                <th style={{ textAlign: 'center' }}>
                  View
                </th>
              </tr>
            </thead>
            <tbody>
              {
                map(globalRoomData, (item, key) => (
                  <Fragment key={key}>
                    <tr>
                      <td className="allUsers-table-col">
                        <Moment format={constants.FORMAT_DATE_TYPE.fullDateSecond} locale={constants.sendLanguage.lv}>
                          {item.date}
                        </Moment>
                      </td>
                      <td className="allUsers-table-col">
                        {item.roomId}
                      </td>
                      <td className="allUsers-table-col">
                        {item.bet}
                      </td>
                      <td className="allUsers-table-col">
                        {item.minGames}
                      </td>
                      <td className="allUsers-table-col">
                        <Button onClick={() => openRoomModal(item)}>
                          View
                        </Button>
                      </td>
                    </tr>
                  </Fragment>
                ))
              }
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={openModalFunc}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

SuspiciousFoldPlayers.propTypes = {
  member: PropTypes.shape({
    email: PropTypes.string,
  }),
  allSuspiciousFoldPlayers: PropTypes.shape({}),
};

SuspiciousFoldPlayers.defaultProps = {
  member: {},
  allSuspiciousFoldPlayers: [],
};

export default SuspiciousFoldPlayers;
